var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4ZM7 0C4.79086 0 3 1.79086 3 4C3 5.41987 3.7398 6.66696 4.85497 7.37682C1.97175 8.4268 0 11.5369 0 15V16H14V15C14 11.5369 12.0283 8.4268 9.14503 7.37682C10.2602 6.66696 11 5.41987 11 4C11 1.79086 9.20914 0 7 0ZM7 9C9.36273 9 11.5268 11.0588 11.9322 14H2.06785C2.4732 11.0588 4.63727 9 7 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.448e9656.svg";
export { ForwardRef as ReactComponent };